import { getCalcInputState } from "../../../../../utils/selectors";
import { leftHipSlice } from "./slice";

export const getLeftHipState = state => getCalcInputState(state)[leftHipSlice.name];